import { useContext, useState } from "react";
import {
  DragDropContext,
  DropResult,
  Droppable,
  DroppableProvided,
} from "@hello-pangea/dnd";
import Column from "./Column";
import reorder, { reorderColumnMap } from "../reorder";
import { BoardContext } from "../context";

const Board = () => {
  const { boardState, setBoardState, addColumn } = useContext(BoardContext);

  const [showAddButton, setShowAddButton] = useState(false);

  const onMouseEnter = () => {
    setShowAddButton(true);
  };

  const onMouseLeave = () => {
    setShowAddButton(false);
  };

  const onDragEnd = (result: DropResult): void => {
    const { source, destination, type } = result;

    if (!destination) return;
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    )
      return;

    if (type === "COLUMN") {
      const ordered: string[] = reorder(
        boardState.ordered,
        source.index,
        destination.index
      );

      setBoardState((prevState) => ({
        ...prevState,
        ordered,
      }));

      return;
    }

    if (type === "ITEM") {
      const data = reorderColumnMap({
        columnMap: boardState.columns,
        source,
        destination,
      });

      setBoardState((prevState) => ({
        ...prevState,
        columns: data.columnMap,
      }));
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="board" type="COLUMN" direction="horizontal">
        {(provided: DroppableProvided) => (
          <div className="flex">
            <div
              className="flex h-[calc(100vh-32px)]"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              <div className="flex">
                {boardState.ordered.map((key: string, index: number) => (
                  <Column
                    key={key}
                    index={index}
                    column={boardState.columns[key]}
                  />
                ))}
              </div>
              {provided.placeholder}
            </div>
            <div
              className="min-w-64"
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            >
              {showAddButton ? (
                <button
                  className="flex flex-col text-lg mt-2 mr-2 p-2 min-w-64 bg-slate-50 border border-dashed border-gray-300 hover:bg-slate-200 rounded-md"
                  onClick={addColumn}
                >
                  <p>Add column</p>
                </button>
              ) : null}
            </div>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default Board;
